<template>
  <div class="container">
    <CommonFrame :workNo="workNo" :btns="btns" :node="node" :moduleName="moduleName"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
      :breadcrumb="breadcrumb"
      :storeInfoId="supplierForm.storeInfo.id" @btnClick='handleClick'>
      <div slot="info">
        <h4>
          <span>供应商编码:</span>
          <span>{{id}}</span>
        </h4>
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <supplierComp slot='formInfo' v-model="supplierForm.storeInfo"
          :able='false'
          :isInStore='true'
          ref='supplierInfo'></supplierComp>
    </CommonFrame>
    <lk-modal v-model="showLog" title="操作日志" footer-hide>
      <div class="records">

        <div class="record" v-for="(item,index) in recordlist" :key='index'>
          {{item}}
        </div>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import axios from 'axios';
import utils from '@/libs/utils';
import supplier from '@/services/supplier';
import goods from '@/services/goods';
import supplierComp from '@/components/supplier.vue';
import CommonFrame from '../commonFrame.vue';

export default {
  name: 'SupplierStorestoreInfo',
  components: {
    CommonFrame,
    supplierComp,
  },
  props: {
    approvalParams: {
      type: Object,
    },
  },
  data() {
    return {
      workNo: '',
      showLog: false,
      logData: [],
      node: '',
      moduleName: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '首营供应商审批',
        },
      ],
      btns: [
        // {
        //   name: 'log',
        //   text: '操作日志',
        //   type: 'default',
        // },
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
      id: '',
      idText: '',
      records: [],
      enterpriseTypeList: ['药品经营', '药品生产', '食品（生产、经营）', '器械生产', '器械经营', '化妆品'],
      able: false,
      infos: null,
      tempForm: null,
      supplierForm: {
        storeInfo: {
          id: '', // 主键
          memoryCode: '', // 助记码
          code: '', // 供应商编码
          name: '', // 供应商名称
          status: '', // 单据状态（1:启用；2:禁用；3:删除）
          rigistryFund: '', // 注册资金
          area: '', // 区域
          postCode: '', // 邮编
          qualityResponsible: '', // 质量负责人
          enterpriseType: [], // 企业类型
          corporationPerson: '', // 企业法人
          rigistryAddress: '', // 注册地址
          socialUnifyCreditCode: '', // 社会统一信用代码
          businessLicenceUrl: '', // 营业执照url
          businessLicenceRange: [],
          businessLicenceDate: '', // 营业执照发证日期 +
          businessLicenceEffecivePeroid: '', // 营业执照有效日期 +
          businessLicenceOffice: '', // 营业执照发证机关 +
          businessLicenceForever: false, // 营业执照永久 +

          drugProdScopeIds: '', // 药品生产范围
          drugProductCredentailCode: '', // 药品生产许可证号
          drugProductCredentailUrl: '', // 药品生产许可证证件照url
          drugProductRange: [], // 药品生产期限
          drugProductDate: '', // 药品生产许可证发证日期
          drugProductEffecivePeroid: '', // 药品生产许可证有效期限
          drugProductOffice: '', // 药品生产许可证发证机关
          gmpCode: '',
          gmpUrl: '', // gmp证书证件照url
          gmpRange: [], // gmp证书证件
          gmpCredentailDate: '', // gmp证书发证日期
          gmpEffecivePeroid: '', // gmp证书有效期限
          gmpCredentailOffice: '', // gmp证书发证机关

          drugBizScopeIds: '', // 药品经营范围
          drugBusinessCredentailUrl: '', // 药品经营许可证证件照url
          drugBusinessCredentailCode: '',
          drugBusinessRange: [], // 药品经营许可证证件照url
          drugBusinessEffecivePeroid: '', // 药品经营许可证有效期限
          drugBusinessOffice: '', // 药品经营许可证发证机关
          drugBusinessDate: '', // 药品经营许可证发证日期
          gspUrl: '', // gsp证书证件照url
          gspCode: '',
          gspRange: [], // gsp证书证件
          gspCredentailOffice: '', // gsp证书发证机关
          gspCredentailDate: '', // gsp证书发证日期
          gspEffecivePeroid: '', // gsp证书有效期限

          equipmentProdScopeIds: '',
          equipmentProdUrl: '',
          equipmentProdCode: '',
          equipmentProdRange: [],
          equipmentProdDate: '',
          equipmentProdExpiry: '',
          equipmentProdOffice: '',

          equipmentBizScopeIds: '',
          secondMediEquiCode: '', // 二类医疗器械生产（经营）企业许可证号
          secondMediEquiUrl: '', // 二类医疗器械生产（经营）企业许可证证件照url
          secondMediEquiCredOffice: '', // 二类医疗器械生产（经营）许可证发证机关
          secondMediEquiCredDate: null, // 二类医疗器械生产（经营）许可证发证日期

          thirdMediEquiCode: '', // 三类医疗器械生产（经营）企业许可证号
          thirdMediEquiUrl: '', // 三类医疗器械生产（经营）企业许可证证件照url
          thirdMediEquiRange: [], // 三类医疗器械生产（经营）企业许可证证件照url
          thirdMediEquiEffecPeroid: '', // 三类医疗器械生产（经营）许可证有效期限
          thirdMediEquiCredOffice: '', // 三类医疗器械生产（经营）许可证发证机关
          thirdMediEquiCredDate: '', // 三类医疗器械生产（经营）许可证发证日期

          foodCredentailCode: '', // 食品生产许可证号
          foodCredentailUrl: '', // 食品生产许可证证件照url
          foodCredentailRange: [], // 食品生产许可证证件照url
          foodEffecivePeroid: '', // 食品生产许可证有效期限
          foodCredentialOffice: '', // 食品生产许可证发证机关
          foodCredentailDate: '', // 食品生产许可证发证日期

          foodBizUrl: '',
          foodBizExpiry: '',
          foodBizOffice: '',
          foodBizDate: '',
          foodBizCode: '',
          foodBizRange: [],

          cosmeticCredentailUrl: '', // 化妆品生产企业卫生许可证证件照url
          cosmeticCredentailCode: '', // 化妆品生产企业卫生许可证号
          cosmeticCredentailOffice: '', // 化妆品生产企业卫生许可证发证机关
          cosmeticCredentailRange: [],
          cosmeticCredentailDate: '',
          cosmeticCredentailPeroid: '',

          otherCredentailUrl: '', // 其他证件证件照url
          otherCredentailCode: '', // 其他证件证件证号
          otherCredentailOffice: '', // 其他证件证件发证机关
          otherCredentailRange: [],
          otherCredentailDate: '',
          otherCredentailPeroid: '',

          otherLicense2Url: '',
          otherLicense2Code: '',
          otherLicense2Office: '',
          otherLicense2Range: [],
          otherLicense2Date: '',
          otherLicense2Expiry: '',

          depositBank: '', // 开户行
          repositoryAddress: '', // 仓库地址
          bankAccount: '', // 银行账号
          qualityEnsureProtocolCode: '', // 质量保证协议编号
          qualityEnsureProtocolUrl: '', // 质量保证协议url
          qualityEnsureEffecivePeroid: '', // 质量协议有效期限
          authorizerName: '', // 授权人姓名
          authorizerEffecivePeroid: '', // 授权书有效期至
          depositaryName: '', // 受托人姓名
          depositaryIdCard: '', // 受托人身份证号
          depositaryIdEffecivePeroid: '', // 受托人身份证有效期限
          followGoodBillCode: '', // 随货通行单单据号
          followGoodBillUrl: '', // 随货通行单单据照url
          stampCode: '', // 印章印模编号
          stampUrl: '', // 印章印模url
          filedDocCode: '', // 文件归档编号
          filedDocState: '', // 业务员备案情况
          filedDocEffecivePeroid: '', // 备案有效期
          qualitiedSupplierTable: '', // 合格供应商档案表
          puchasePersonSuggestion: '', // 采购员意见
          storeId: '',
          storeName: '',
          createUserId: '',
          createUserName: '',
          createTime: '',
          refOriginId: '',
          accountProid: '',
          payWay: '',
          creditLimit: '',
        },
      },
      drugProdLabelList: [],
      drugBizLabelList: [],
      equipmentProdLabelList: [],
    };
  },
  computed: {
    recordlist() {
      const result = [];
      this.logData.forEach((el, index) => {
        let str = `${index + 1}.${el.time}, 由 ${el.name}${el.content} 。`;
        if (el.newValue && el.oldValue) {
          str += `修改了 是否医保点，旧值：${el.oldValue}，新值：${el.newValue}.`;
        }
        result.push(str);
        // 1.2019/01/14 12:24:30, 由 张三 创建。
      });
      return result;
    },
    enterpriseTypeNames() {
      if (this.supplierForm.storeInfo.enterpriseType.map) {
        const resArr = this.supplierForm.storeInfo.enterpriseType.map(item => this.enterpriseTypeList[item - 1]);
        return resArr.join(';');
      }
      return '';
    },
  },
  methods: {
    handleClick(text) {
      if (text === 'log') {
        this.getRecord();
        this.showLog = true;
      }
    },
    getInfos(businessUrl) {
      return new Promise((resolve) => {
        axios.get(businessUrl).then((res) => {
          if (res.data.status === 200) {
            const { data } = res.data;
            this.tempForm = utils.deepClone(data.storeInfo);
            this.exchangeDateArr(data.storeInfo);
            for (const key in data.storeInfo) {
              if (key.includes('createTime') || key.includes('Peroid') || key.includes('Date')) {
                if (key !== 'secondMediEquiCredDate') {
                  data.storeInfo[key] = new Date(data.storeInfo[key]);
                }
              }
            }
            data.storeInfo.enterpriseType = data.storeInfo.enterpriseType ? data.storeInfo.enterpriseType.split(',') : [];
            data.storeInfo.drugProdScopeIds = data.storeInfo.drugProdScopeIds ? data.storeInfo.drugProdScopeIds.split(',') : [];
            data.storeInfo.drugBizScopeIds = data.storeInfo.drugBizScopeIds ? data.storeInfo.drugBizScopeIds.split(',') : [];
            data.storeInfo.equipmentProdScopeIds = data.storeInfo.equipmentProdScopeIds ? data.storeInfo.equipmentProdScopeIds.split(',') : [];
            data.storeInfo.equipmentBizScopeIds = data.storeInfo.equipmentBizScopeIds ? data.storeInfo.equipmentBizScopeIds.split(',') : [];
            for (const key in data.storeInfo) {
              if (key.includes('Range')) {
                if (!data.storeInfo[key][0]) {
                  data.storeInfo[key] = [];
                }
              }
            }
            Object.assign(this.supplierForm, data);
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    exchangeDateArr(data) {
      data.businessLicenceRange = [];
      data.drugProductRange = [];
      data.gmpRange = [];
      data.drugBusinessRange = [];
      data.gspRange = [];
      data.equipmentProdRange = [];
      data.thirdMediEquiRange = [];
      data.foodCredentailRange = [];
      data.foodBizRange = [];
      data.cosmeticCredentailRange = [];
      data.otherCredentailRange = [];
      data.otherLicense2Range = [];
      if (data.businessLicenceEffecivePeroid) {
        data.businessLicenceRange[0] = data.businessLicenceDate; // ? new Date(data.businessLicenceDate) : '';
        data.businessLicenceRange[1] = data.businessLicenceEffecivePeroid; // ? new Date(data.businessLicenceEffecivePeroid) : '';
      }
      if (data.drugProductEffecivePeroid) {
        data.drugProductRange[0] = data.drugProductDate; // ? new Date(data.businessLicenceDate) : '';
        data.drugProductRange[1] = data.drugProductEffecivePeroid; // ? new Date(data.businessLicenceEffecivePeroid) : '';
      }
      if (data.gmpEffecivePeroid) {
        data.gmpRange[0] = data.gmpCredentailDate; // ? new Date(data.gmpCredentailDate) : '';
        data.gmpRange[1] = data.gmpEffecivePeroid; // ? new Date(data.gmpEffecivePeroid) : '';
      }
      if (data.drugBusinessEffecivePeroid) {
        data.drugBusinessRange[0] = data.drugBusinessDate; // ? new Date(data.drugBusinessDate) : '';
        data.drugBusinessRange[1] = data.drugBusinessEffecivePeroid; // ? new Date(data.drugBusinessEffecivePeroid) : '';
      }
      if (data.gspEffecivePeroid) {
        data.gspRange[0] = data.gspCredentailDate; // ? new Date(data.gspCredentailDate) : '';
        data.gspRange[1] = data.gspEffecivePeroid; // ? new Date(data.gspEffecivePeroid) : '';
      }
      if (data.equipmentProdExpiry) {
        data.equipmentProdRange[0] = data.equipmentProdDate; // ? new Date(data.gspCredentailDate) : '';
        data.equipmentProdRange[1] = data.equipmentProdExpiry; // ? new Date(data.gspEffecivePeroid) : '';
      }
      if (data.secondMediEquiCredDate) {
        data.secondMediEquiCredDate = new Date(data.secondMediEquiCredDate);
      }
      if (data.thirdMediEquiEffecPeroid) {
        data.thirdMediEquiRange[0] = data.thirdMediEquiCredDate; // ? new Date(data.thirdMediEquiCredDate) : '';
        data.thirdMediEquiRange[1] = data.thirdMediEquiEffecPeroid; // ? new Date(data.thirdMediEquiEffecPeroid) : '';
      }
      if (data.foodEffecivePeroid) {
        data.foodCredentailRange[0] = data.foodCredentailDate; // ? new Date(data.foodCredentailDate) : '';
        data.foodCredentailRange[1] = data.foodEffecivePeroid; // ? new Date(data.foodEffecivePeroid) : '';
      }
      if (data.foodBizExpiry) {
        data.foodBizRange[0] = data.foodBizDate; // ? new Date(data.foodCredentailDate) : '';
        data.foodBizRange[1] = data.foodBizExpiry; // ? new Date(data.foodEffecivePeroid) : '';
      }
      if (data.cosmeticCredentailPeroid) {
        data.cosmeticCredentailRange[0] = data.cosmeticCredentailDate; // ? new Date(data.cosmeticCredentailDate) : '';
        data.cosmeticCredentailRange[1] = data.cosmeticCredentailPeroid; // ? new Date(data.cosmeticCredentailPeroid) : '';
      }
      if (data.otherCredentailPeroid) {
        data.otherCredentailRange[0] = data.otherCredentailDate; // ? new Date(data.otherCredentailDate) : '';
        data.otherCredentailRange[1] = data.otherCredentailPeroid; // ? new Date(data.otherCredentailPeroid) : '';
      }
      if (data.otherLicense2Expiry) {
        data.otherLicense2Range[0] = data.otherLicense2Date; // ? new Date(data.otherCredentailDate) : '';
        data.otherLicense2Range[1] = data.otherLicense2Expiry; // ? new Date(data.otherCredentailPeroid) : '';
      }
      const {
        provinceId, cityId, countyId, provinceName, cityName, countyName,
      } = data;

      if (provinceId && cityId && countyId) {
        data.locationArr = [provinceId, cityId, countyId];
      }
      if (provinceName && cityName && countyName) {
        data.locationStr = [provinceName, cityName, countyName].join('/');
      }
    },
    handleProductScope() {
      goods.GoodsDictionary({ dictionaryTypeEnum: 13 }).then((res) => {
        if (res.data.status === 200) {
          this.productScopeTree = [];

          res.data.data.forEach((item) => {
            const productItem = {
              title: item.dictionaryName,
              id: item.id,
              // disabled: !this.able,

            };
              // this.businessScopeTree.push(businessItem);

            this.productScopeTree.push(productItem);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getScope() {
      this.businessScopeTree = [];

      // this.productScopeTree = [];


      return new Promise((resolve) => {
        supplier.supplierScope().then((res) => {
          if (res.data.status === 200) {
            const { data } = res.data;
            // console.log(data);
            data[0].supplierBusinessLabelVoList.forEach((item) => {
              const businessItem = {
                title: item.name,
                id: item.id,
                // disabled: !this.able,

              };

              this.businessScopeTree.push(businessItem);

              // this.productScopeTree.push(productItem);
            });

            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },

    getTitleInfo() {
      supplier.supplierInfo({ originType: 2, id: this.supplierForm.storeInfo.id }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.idText = '供应商编码';
          this.id = data.code;
          this.infosArr.push(
            { name: '创建人', value: data.createUserName },
            { name: '创建时间', value: data.createTime ? utils.exchangeTimeToSecond(data.createTime) : '' },
            { name: '最后修改人', value: data.lastModifiedUserName },
            { name: '最后修改时间', value: data.lastMmodifiedTime ? utils.exchangeTimeToSecond(data.lastMmodifiedTime) : '' },
          );
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRecord() {
      supplier.getRecord({ originType: 2, refOriginId: this.supplierForm.storeInfo.id }).then((res) => {
        if (res.data.status === 200) {
          // this.record
          this.logData = [];

          res.data.data.forEach((item) => {
            const format = {
              content: item.content,
              newValue: item.newValue,
              oldValue: item.oldValue,
              time: utils.exchangeTimeToSecond(item.time),
              Id: item.userId,
              name: item.userName,
            };
            this.logData.push(format);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getLabelList(type) {
      supplier.goodsLabelList({
        page: 1,
        size: 1000,
        goodsLabelCategory: type,
      }).then((res) => {
        let labelListName = '';
        if (type === 2) {
          labelListName = 'drugBizLabelList';
        }
        if (type === 4) {
          labelListName = 'drugProdLabelList';
        }
        if (type === 5) {
          labelListName = 'equipmentProdLabelList';
        }
        if (res.data.status === 200 && res.data.data.list) {
          this[labelListName] = res.data.data.list;
        }
      });
    },
    getDrugBizLabelList() {
      this.getLabelList(2);
    },
    getDrugProdLabelList() {
      this.getLabelList(4);
    },
    getEquipmentProd() {
      this.getLabelList(5);
    },

  },

  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.moduleName = this.approvalParams.moduleName;

    this.getDrugBizLabelList();
    this.getDrugProdLabelList();
    this.getEquipmentProd();
    this.getInfos(this.approvalParams.businessUrl).then(() => {
      this.getTitleInfo();
    });
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .demo-auto-complete-item{
    width: 650px
  }
  .searchItem{
    display: inline-block;
    width: 25%;
  }
  .noThing{
    height: 36px;
    line-height: 36px;
    padding-left: 16px;
    color: rgba(0, 0, 0, 0.25)
  }
  .record{
  font-size: 14px;
  padding: 0 10px;
  line-height: 2
}
.records{
  max-height: 60vh;
  overflow: auto
}
</style>
